import { useEffect } from "react";

/**
 * Globalny hook do detekcji nawigacji klawiaturą.
 * - Tab → ustawia data-keyboard-user="true" na <html> (widoczne focus ringi)
 * - Mouse click → usuwa data-keyboard-user (ukrywa focus ringi)
 * - Escape → blur aktywnego elementu (zamyka dropdowny)
 */
export const useKeyboardNavigation = () => {
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Tab") {
                document.documentElement.setAttribute("data-keyboard-user", "true");
            }
        };

        const handleMouseDown = () => {
            document.documentElement.removeAttribute("data-keyboard-user");
        };

        const handleEscape = (e) => {
            if (e.key === "Escape") {
                const activeElement = document.activeElement;
                if (activeElement && activeElement !== document.body) {
                    activeElement.blur();
                }
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keydown", handleEscape);
        document.addEventListener("mousedown", handleMouseDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keydown", handleEscape);
            document.removeEventListener("mousedown", handleMouseDown);
        };
    }, []);
};
